var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-wrap",style:({
  textAlign: _vm.formData.textAlign,
  background: _vm.formData.background
})},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formData.showLine),expression:"formData.showLine"}],staticClass:"line",style:({
    background: _vm.formData.color
   })}),_c('div',{staticClass:"title-text",style:({
    fontSize: _vm.formData.fontSize,
    color: _vm.formData.color
   })},[_vm._v(" "+_vm._s(_vm.formData.text || '标题')+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.formData.showLine),expression:"formData.showLine"}],staticClass:"line",style:({
    background: _vm.formData.color
   })})])}
var staticRenderFns = []

export { render, staticRenderFns }